import React from 'react';
import { ArrowLeft, Star, Eye, Plus } from '@phosphor-icons/react';
import { PAGE_ROUTE } from '../lib/routes';
import { LandlordIdentityCard, LandlordIdentityData } from '../components/dashboard/LandlordIdentityCard';
import { ReviewCard, Review, ReviewsRatingSummary, getPublicReviews } from '../components/dashboard/ReviewCard';
import { LandlordRentalHistory, LandlordRentalEntry } from '../components/dashboard/LandlordRentalHistory';
import { getSession, getOffersFromSupply, hasCompletedRentalBetween, getStoredReviewsForSubject, hasReviewedSubject, StoredReview } from '../lib/utils';
interface LandlordProfileProps {
  navigate: (page: string, context?: any) => void;
  context?: {
    slug?: string;
    viewerIsOwner?: boolean;
  };
}
interface LandlordMockProfile {
  slug: string;
  data: LandlordIdentityData;
  reviews: Review[];
  rentalHistory?: LandlordRentalEntry[];
}
const MOCK_PROFILES: Record<string, LandlordMockProfile> = {
  'andrei-proprietar': {
    slug: 'andrei-proprietar',
    data: {
      name: 'Vlad Constantin',
      avatar: 'https://i.pravatar.cc/200?img=68',
      subRole: 'proprietar',
      memberSince: 2024,
      linkedinUrl: 'https://linkedin.com/in/vlad-constantin',
      facebookUrl: 'https://facebook.com/vlad.constantin',
      bio: 'Sunt un proprietar implicat și comunicativ. Apartamentele mele sunt mereu renovate la zi și încerc să răspund rapid la mesajele chiriașilor. Caut chiriași responsabili pentru închiriere pe termen lung.',
      verifications: {
        email: true,
        identity: true,
        business: true
      },
      stats: {
        oferteTrimise: 12,
        inchirieriDeSuccess: 4
      }
    },
    reviews: [{
      id: 'r1',
      reviewerName: 'Mihaela R.',
      reviewerRole: 'Chiriaș' as any,
      reviewerSlug: 'mihaela-r',
      reviewerVerified: true,
      rating: 5,
      categoryRatings: {
        cleanliness: 5,
        communication: 5,
        payments: 5,
        rules: 5
      },
      date: 'Aprilie 2026',
      body: 'Vlad a fost un proprietar excelent. Răspunde rapid, apartamentul era exact ca în anunț, fără surprize. A rezolvat o problemă cu boilerul în mai puțin de 24h. Recomand cu încredere.',
      periodLabel: 'Mai 2024 – Aprilie 2026',
      status: 'transactional',
      avatar: 'https://i.pravatar.cc/80?img=45'
    }, {
      id: 'r2',
      reviewerName: 'Cristian D.',
      reviewerRole: 'Chiriaș' as any,
      reviewerSlug: 'cristian-d',
      reviewerVerified: false,
      rating: 5,
      categoryRatings: {
        cleanliness: 5,
        communication: 5,
        payments: 5,
        rules: 4
      },
      date: 'Februarie 2024',
      body: 'Am stat 18 luni în chirie la Vlad. Foarte ok, fără probleme, comunicare directă. Returnarea garanției a durat 3 zile, complet legal.',
      periodLabel: 'August 2022 – Februarie 2024',
      status: 'transactional',
      avatar: 'https://i.pravatar.cc/80?img=53'
    }],
    rentalHistory: [{
      id: 'rh1',
      tenantName: 'Mihaela R.',
      tenantAvatar: 'https://i.pravatar.cc/80?img=45',
      listingTitle: 'Apartament 2 camere Floreasca',
      closedAt: '2026-04-15T00:00:00.000Z',
      periodLabel: 'Mai 2024 – Aprilie 2026'
    }, {
      id: 'rh2',
      tenantName: 'Cristian D.',
      tenantAvatar: 'https://i.pravatar.cc/80?img=53',
      listingTitle: 'Studio Aviatorilor',
      closedAt: '2024-02-10T00:00:00.000Z',
      periodLabel: 'August 2022 – Februarie 2024'
    }, {
      id: 'rh3',
      tenantName: 'Andrei B.',
      listingTitle: 'Apartament 3 camere Primăverii',
      closedAt: '2022-06-01T00:00:00.000Z',
      periodLabel: 'Iulie 2020 – Iunie 2022'
    }, {
      id: 'rh4',
      tenantName: 'Elena T.',
      listingTitle: 'Garsonieră Cotroceni',
      closedAt: '2020-05-15T00:00:00.000Z',
      periodLabel: 'Iunie 2018 – Mai 2020'
    }]
  },
  'maria-agent': {
    slug: 'maria-agent',
    data: {
      name: 'Diana Popescu',
      avatar: 'https://i.pravatar.cc/200?img=49',
      subRole: 'agent',
      agencyName: 'Imobiliare Premium',
      memberSince: 2023,
      linkedinUrl: 'https://linkedin.com/in/diana-popescu',
      websiteUrl: 'https://imobiliarepremium.ro',
      bio: 'Agent imobiliar cu 8 ani experiență în zonele Floreasca, Aviatorilor și Primăverii. Specializată în închirieri premium pentru expați și profesioniști. Lucrez doar cu proprietari verificați și chiriași evaluați.',
      verifications: {
        email: true,
        identity: true,
        business: false
      },
      stats: {
        oferteTrimise: 47,
        inchirieriDeSuccess: 18
      }
    },
    reviews: [{
      id: 'r1',
      reviewerName: 'Robert C.',
      reviewerRole: 'Chiriaș' as any,
      reviewerSlug: 'robert-c',
      reviewerVerified: true,
      rating: 5,
      categoryRatings: {
        cleanliness: 5,
        communication: 5,
        payments: 5,
        rules: 5
      },
      date: 'Martie 2026',
      body: 'Diana m-a ajutat să găsesc un apartament în mai puțin de 2 săptămâni, exact în zona pe care o căutam. Profesionistă, organizată, mereu disponibilă la telefon. Recomand!',
      periodLabel: 'Februarie 2024 – Martie 2026',
      status: 'transactional',
      avatar: 'https://i.pravatar.cc/80?img=12'
    }, {
      id: 'r2',
      reviewerName: 'Elena F.',
      reviewerRole: 'Chiriaș' as any,
      reviewerSlug: 'elena-f',
      reviewerVerified: true,
      rating: 5,
      categoryRatings: {
        cleanliness: 5,
        communication: 5,
        payments: 5,
        rules: 5
      },
      date: 'Ianuarie 2026',
      body: 'O agentă cu adevărat de încredere. A făcut tot procesul lipsit de stres — vizionări, negociere, contract. Tot ce a promis s-a întâmplat.',
      periodLabel: 'Septembrie 2024 – Ianuarie 2026',
      status: 'transactional',
      avatar: 'https://i.pravatar.cc/80?img=27'
    }, {
      id: 'r3',
      reviewerName: 'Ștefan B.',
      reviewerRole: 'Chiriaș' as any,
      reviewerSlug: 'stefan-b',
      reviewerVerified: false,
      rating: 4,
      categoryRatings: {
        cleanliness: 4,
        communication: 5,
        payments: 5,
        rules: 4
      },
      date: 'Octombrie 2025',
      body: 'Comunicare foarte bună, a găsit chiriași solizi. Singurul reproș — un mic delay pe semnătura contractului, dar s-a rezolvat în câteva zile.',
      periodLabel: 'Mai 2023 – Octombrie 2025',
      status: 'verified_by_document',
      avatar: 'https://i.pravatar.cc/80?img=33'
    }],
    rentalHistory: [{
      id: 'rh1',
      tenantName: 'Robert C.',
      tenantAvatar: 'https://i.pravatar.cc/80?img=12',
      listingTitle: 'Apartament 3 camere Floreasca',
      closedAt: '2026-03-01T00:00:00.000Z',
      periodLabel: 'Februarie 2024 – Martie 2026'
    }, {
      id: 'rh2',
      tenantName: 'Elena F.',
      tenantAvatar: 'https://i.pravatar.cc/80?img=27',
      listingTitle: 'Penthouse Aviatorilor',
      closedAt: '2026-01-10T00:00:00.000Z',
      periodLabel: 'Septembrie 2024 – Ianuarie 2026'
    }, {
      id: 'rh3',
      tenantName: 'Ștefan B.',
      tenantAvatar: 'https://i.pravatar.cc/80?img=33',
      listingTitle: 'Apartament 2 camere Primăverii',
      closedAt: '2025-10-05T00:00:00.000Z',
      periodLabel: 'Mai 2023 – Octombrie 2025'
    }]
  },
  'george-agent-solo': {
    slug: 'george-agent-solo',
    data: {
      name: 'Robert Marinescu',
      avatar: undefined,
      subRole: 'agent',
      memberSince: 2026,
      verifications: {
        email: true,
        identity: false,
        business: false
      },
      stats: {
        oferteTrimise: 1,
        inchirieriDeSuccess: 0
      }
    },
    reviews: []
  }
};
export function LandlordProfile({
  navigate,
  context
}: LandlordProfileProps) {
  const slug = context?.slug || 'andrei-proprietar';
  const viewerIsOwner = !!context?.viewerIsOwner;
  const profile = MOCK_PROFILES[slug] || MOCK_PROFILES['andrei-proprietar'];
  const session = getSession();
  // L8.3 — when the owner is previewing their own public profile, read real
  // rental history from the offer store instead of mock data.
  const realOwnerHistory: LandlordRentalEntry[] = viewerIsOwner && session?.role === 'supply' && session.email ? getOffersFromSupply(session.email).filter(o => o.status === 'succes').map(o => ({
    id: o.id,
    tenantName: o.toName,
    listingTitle: o.listingPreview?.title,
    closedAt: o.succesAt || o.updatedAt
  })) : [];
  const rentalEntries: LandlordRentalEntry[] = viewerIsOwner && session?.role === 'supply' ? realOwnerHistory : profile.rentalHistory || [];
  return <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6" data-id="element-3651">
      {/* Back button */}
      <button type="button" onClick={() => {
      if (viewerIsOwner && session?.role === 'supply') {
        navigate(PAGE_ROUTE.DASHBOARD_PROFIL);
      } else {
        navigate(PAGE_ROUTE.MARKETPLACE);
      }
    }} className="inline-flex items-center gap-2 text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-3652">
        <ArrowLeft size={16} data-id="element-3653" />
        {viewerIsOwner ? 'Înapoi la profil' : 'Înapoi'}
      </button>

      {/* Owner preview banner */}
      {viewerIsOwner && <div className="rounded-2xl bg-lime-5 border border-lime-4 px-5 py-4 flex items-start gap-3" data-id="element-3654">
          <Eye size={20} weight="fill" className="text-lime-1 shrink-0 mt-0.5" data-id="element-3655" />
          <div className="flex-1 min-w-0" data-id="element-3656">
            <h3 className="text-sm font-semibold text-light-1" data-id="element-3657">
              Așa arată profilul tău
            </h3>
            <p className="text-xs text-light-2 mt-0.5" data-id="element-3658">
              Așa te văd chiriașii când le trimiți o ofertă.
            </p>
          </div>
        </div>}

      {/* Identity card */}
      <LandlordIdentityCard data={profile.data} mode="public" data-id="element-3659" />

      {/* Reviews section */}
      <section className="rounded-2xl bg-dark-2 border border-dark-3 px-6 py-7" data-id="element-3660">
        {(() => {
        // Merge mock seed reviews with reviews submitted through the
        // ReviewSubmission flow (persisted in localStorage). Stored reviews
        // are mapped into the same Review shape ReviewCard already renders.
        const stored = getStoredReviewsForSubject(slug).map((r: StoredReview): Review => ({
          id: r.id,
          reviewerName: r.reviewerName,
          reviewerRole: r.reviewerRole as any,
          reviewerSlug: r.reviewerSlug,
          reviewerVerified: r.reviewerVerified,
          avatar: r.reviewerAvatar,
          rating: r.rating,
          categoryRatings: r.categoryRatings,
          date: r.date,
          body: r.body,
          periodLabel: '',
          status: r.status
        }));
        // Stored first — user-submitted reviews surface at the top.
        const allReviews: Review[] = [...stored, ...profile.reviews];
        // On public profiles we hide pending/unverified reviews — only show
        // transactional + document-verified. Aggregate rating uses the same
        // filtered set so the headline number matches what the visitor sees.
        const publicReviews = getPublicReviews(allReviews);
        const handleReviewerClick = (slug: string) => {
          navigate(PAGE_ROUTE.TENANT_PROFILE, {
            slug
          });
        };
        // Tenant viewers who completed a rental with this supply can leave
        // a review directly from this section. Interaction-gated trust,
        // and gated again once they've already submitted one.
        const alreadyReviewed = hasReviewedSubject(session?.slug, slug);
        const canReview = !viewerIsOwner && session?.role === 'demand' && !!session.slug && hasCompletedRentalBetween(slug, session.slug) && !alreadyReviewed;
        const handleLeaveReview = () => {
          if (!session?.slug) return;
          const subjectType: 'landlord' | 'agent' = profile.data.subRole === 'agent' ? 'agent' : 'landlord';
          navigate(PAGE_ROUTE.REVIEW_SUBMISSION, {
            token: `inline-${slug}-${session.slug}`,
            subjectType,
            subjectName: profile.data.name,
            subjectSlug: slug,
            targetSlug: session.slug
          });
        };
        return <>
              <div className="flex items-center justify-between mb-4" data-id="element-3661">
                <h2 className="text-base font-semibold text-light-1" data-id="element-3662">
                  Recenzii
                </h2>
                <ReviewsRatingSummary reviews={publicReviews} data-id="element-3663" />
              </div>

              {publicReviews.length === 0 ? <div className="rounded-xl border border-dashed border-dark-4 p-6 text-center" data-id="element-3664">
                  <Star size={36} weight="regular" className="text-light-4 mx-auto mb-3" data-id="element-3665" />
                  <p className="text-sm text-light-3 leading-relaxed" data-id="element-3666">
                    Acest{' '}
                    {profile.data.subRole === 'agent' ? 'agent' : 'proprietar'}{' '}
                    nu are încă recenzii pe Izio.
                  </p>
                </div> : <div className="space-y-4" data-id="element-3667">
                  {publicReviews.map(r => <ReviewCard key={r.id} review={r} onReviewerClick={handleReviewerClick} data-id="element-3668" />)}
                </div>}

              {canReview && <div className="pt-4" data-id="element-3669">
                  <button type="button" onClick={handleLeaveReview} className="inline-flex items-center gap-1.5 h-9 px-4 rounded-lg bg-dark-3 hover:bg-dark-4 text-light-1 text-xs font-medium border border-dark-4 transition-colors cursor-pointer" data-id="element-3670">
                    <Plus size={14} weight="bold" data-id="element-3671" />
                    Lasă o recenzie
                  </button>
                </div>}
            </>;
      })()}
      </section>

      {/* L8.3 — Rental history (real for owner, mock otherwise) */}
      <LandlordRentalHistory entries={rentalEntries} isOwner={viewerIsOwner} subRole={profile.data.subRole} data-id="element-3672" />

      {/* Trust footer */}
      <p className="text-xs text-light-4 text-center" data-id="element-3673">
        Acest profil este parte din Izio — rețeaua de încredere pentru
        închirieri pe termen lung.
      </p>
    </div>;
}